var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    fill: "white",
    height: 58,
    width: 58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    clipPath: "url(#clip0_23_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#38BFF2",
    d: "m57.103,3.53382l0,8.16778l-56.20603,0l0,-8.16778c0,-1.45895 1.1779,-2.63685 2.63685,-2.63685l50.93238,0c1.4589,0 2.6368,1.1779 2.6368,2.63685z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#D7E9FF",
    d: "m8.11732,6.29652c0,0.76113 -0.61772,1.37897 -1.37897,1.37897c-0.76125,0 -1.37897,-0.61772 -1.37897,-1.37897c0,-0.76125 0.61772,-1.37342 1.37897,-1.37342c0.76125,0 1.37897,0.61228 1.37897,1.37342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#D7E9FF",
    d: "m13.9479,6.29652c0,0.76113 -0.6177,1.37897 -1.379,1.37897c-0.7612,0 -1.379,-0.61772 -1.379,-1.37897c0,-0.76125 0.6178,-1.37342 1.379,-1.37342c0.7613,0 1.379,0.61228 1.379,1.37342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#D7E9FF",
    d: "m19.7789,6.29652c0,0.76113 -0.6177,1.37897 -1.3789,1.37897c-0.7613,0 -1.379,-0.61772 -1.379,-1.37897c0,-0.76125 0.6177,-1.37342 1.379,-1.37342c0.7612,0 1.3789,0.61228 1.3789,1.37342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#D7E9FF",
    d: "m52.6399,6.29561c0,0.76159 -0.6225,1.37671 -1.384,1.37671l-14.5945,0c-0.7616,0 -1.3767,-0.61512 -1.3767,-1.37671c0,-0.76159 0.6151,-1.36934 1.3767,-1.36934l14.5946,0c0.7614,0 1.3839,0.60775 1.3839,1.36934z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#1A2E35",
    d: "m54.466,0.29895l-50.9322,0c-1.78384,0 -3.23497,1.45102 -3.23497,3.23497l0,50.93828c0,1.7803 1.45102,3.2289 3.23497,3.2289l50.9322,0c1.7838,0 3.2349,-1.4485 3.2349,-3.2289c0,-6.4 0,-43.3491 0,-50.93828c0,-1.78395 -1.451,-3.23497 -3.2349,-3.23497zm-52.97126,3.23497c0,-1.12431 0.91497,-2.03906 2.03906,-2.03906l50.9322,0c1.1241,0 2.039,0.91475 2.039,2.03906l0,7.56968l-55.01026,0l0,-7.56968zm55.01026,50.93828c0,1.1208 -0.9149,2.0329 -2.039,2.0329l-50.9322,0c-1.12409,0 -2.03906,-0.9121 -2.03906,-2.0329l0,-42.1727l55.01026,0l0,42.1727z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "white",
    d: "m57.211681,12.358331l0,42.7704c0,1.459 -1.1779,2.631 -2.6368,2.631l-50.93238,0c-1.45895,0 -2.63685,-1.172 -2.63685,-2.631l0,-42.7704l56.20603,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#1A2E35",
    d: "m6.73825,4.32507c-1.08965,0 -1.97653,0.88439 -1.97653,1.97132c0,1.09022 0.88699,1.97687 1.97653,1.97687c1.09022,0 1.97721,-0.88665 1.97721,-1.97687c-0.00011,-1.08693 -0.8871,-1.97132 -1.97721,-1.97132zm0,2.7524c-0.43036,0 -0.78073,-0.35038 -0.78073,-0.78096c0,-0.42775 0.35037,-0.77541 0.78073,-0.77541c0.43092,0 0.7813,0.34777 0.7813,0.77541c-0.00011,0.43058 -0.35038,0.78096 -0.7813,0.78096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#1A2E35",
    d: "m12.5695,4.32507c-1.0902,0 -1.9772,0.88439 -1.9772,1.97132c0,1.09022 0.887,1.97687 1.9772,1.97687c1.0896,0 1.9765,-0.88665 1.9765,-1.97687c0,-1.08693 -0.887,-1.97132 -1.9765,-1.97132zm0,2.7524c-0.4309,0 -0.7813,-0.35038 -0.7813,-0.78096c0,-0.42775 0.3504,-0.77541 0.7813,-0.77541c0.4304,0 0.7807,0.34777 0.7807,0.77541c0,0.43058 -0.3503,0.78096 -0.7807,0.78096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#1A2E35",
    d: "m18.4001,4.32507c-1.0903,0 -1.9772,0.88439 -1.9772,1.97132c0,1.09022 0.8869,1.97687 1.9772,1.97687c1.0896,0 1.9765,-0.88665 1.9765,-1.97687c0,-1.08693 -0.887,-1.97132 -1.9765,-1.97132zm0,2.7524c-0.431,0 -0.7813,-0.35038 -0.7813,-0.78096c0,-0.42775 0.3503,-0.77541 0.7813,-0.77541c0.4303,0 0.7807,0.34777 0.7807,0.77541c0,0.43058 -0.3504,0.78096 -0.7807,0.78096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#1A2E35",
    d: "m51.2559,4.32837l-14.5945,0c-1.089,0 -1.9749,0.88257 -1.9749,1.96724c0,1.08897 0.8859,1.97483 1.9749,1.97483l14.5945,0c1.0925,0 1.9819,-0.88586 1.9819,-1.97483c0,-1.08467 -0.8894,-1.96724 -1.9819,-1.96724zm0,2.74616l-14.5945,0c-0.4298,0 -0.779,-0.34947 -0.779,-0.77892c0,-0.43239 0.3423,-0.77133 0.779,-0.77133l14.5945,0c0.4334,0 0.786,0.34596 0.786,0.77133c0,0.42945 -0.3526,0.77892 -0.786,0.77892z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_19",
    height: 29.041063,
    width: 21.369841,
    y: 25.575345,
    x: 5.849336,
    strokeWidth: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_20",
    height: 29.041063,
    width: 10.410948,
    y: 25.575345,
    x: 16.808228,
    strokeWidth: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_21",
    y2: 43.35091,
    x2: 14.342477,
    y1: 37.356152,
    x1: 14.384381,
    strokeWidth: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_23",
    y2: 43.586204,
    x2: 19.213648,
    y1: 37.426157,
    x1: 19.090265,
    strokeWidth: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_25",
    height: 4.705882,
    width: 21.647059,
    y: 40.392316,
    x: 27.235291,
    fillOpacity: "null",
    strokeWidth: "null",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_27",
    height: 4.705882,
    width: 21.647059,
    y: 45.168202,
    x: 27.235291,
    fillOpacity: "null",
    strokeWidth: "null",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    id: "svg_28",
    height: 4.705882,
    width: 21.647059,
    y: 50.084099,
    x: 27.235291,
    fillOpacity: "null",
    strokeWidth: "null",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_29",
    y2: 42.140495,
    x2: 40.157024,
    y1: 42.305784,
    x1: 36.355371,
    fillOpacity: "null",
    strokeWidth: "null",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_30",
    y2: 46.933883,
    x2: 40.157024,
    y1: 47.099172,
    x1: 36.355371,
    fillOpacity: "null",
    strokeWidth: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_31",
    y2: 51.727249,
    x2: 40.652892,
    y1: 51.72731,
    x1: 36.355372,
    fillOpacity: "null",
    strokeWidth: "null",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experience-icon.d36d526c08733404698024f06c471c1f.svg";
export { ForwardRef as ReactComponent };